import { render, staticRenderFns } from "./bugs.vue?vue&type=template&id=137711aa&"
import script from "./bugs.vue?vue&type=script&lang=js&"
export * from "./bugs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports